import { useMediaQuery } from "react-responsive";

import { QUERY_WIDTHS } from "@utils/index";
import { MileageModel } from "@interfaces/index";
import { TableTdMobileMileage, TableTdDesktopMileage } from "@components/index";

export const TableRowMileage = ({
  mileage,
  isDiBusiness = false,
  onDetails,
  onEdit,
  onRemove,
}: {
  mileage: MileageModel;
  isDiBusiness: boolean;
  onDetails?: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
}) => {
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });

  return isMobile ? (
    <TableTdMobileMileage
      mileage={mileage}
      isDiBusiness={isDiBusiness}
      onClickRow={onDetails}
    />
  ) : (
    <TableTdDesktopMileage
      mileage={mileage}
      isDiBusiness={isDiBusiness}
      onClickRow={onDetails}
      onEdit={onEdit}
      onRemove={onRemove}
    />
  );
};
